module.exports = __webpack_public_path__ + "static/media/referral-program-2.c124d261.jpg";